<script setup>
defineProps({
    title: String,
    icon: String,
    color: String,
    onlyIconMobile: Boolean,
    disabled: Boolean,
    roundness: {
        type: String,
        default: 'rounded-xl'
    },
    horizontal: Boolean,
    disabledOverlay: String
})
</script>

<template>
    <div
        class="action-card group transition-all backdrop-blur-lg flex items-center gap-3 text-center  border-gray-200 dark:border-neutral-700 bg-white/90 dark:bg-gray-800"
        style="overflow: hidden;"
        v-tooltip="disabled ? disabledOverlay : null"
        :class="[onlyIconMobile ? 'md:border md:p-2 md:py-4' : 'border p-2 py-4',roundness, `hover:border-${color}-400 dark:hover:border-${color}-600`, disabled ? 'opacity-70 cursor-no-drop' : 'cursor-pointer hover:scale-105 hover:shadow-xl ', horizontal ? (onlyIconMobile ? 'flex-row md:px-3 md:pr-4 w-full sm:w-auto' : 'flex-row px-3 pr-4 w-full sm:w-auto'): (onlyIconMobile ? '' : ' flex-col w-[140px]')]"
    >
        <div
            class="icon-wrapper flex items-center justify-center rounded-full  transition-transform group-hover:scale-110"
            :class="[`bg-${color}-50 dark:bg-${color}-900 text-${color}-500 dark:text-${color}-300`, horizontal ? (onlyIconMobile ? 'px-4 h-10 md:w-8 md:h-8 ' : 'w-8 h-8 ') : 'w-12 h-12 ']"
        >
            <i :class="[icon, horizontal ? '!text-sm' : '!text-xl']"></i>
            <p v-if="onlyIconMobile" class="title text-xs font-semibold text-gray-700 dark:text-gray-200 transition-colors ml-2" :class="[`group-hover:text-${color}-500 dark:group-hover:text-${color}-300`, onlyIconMobile ? 'md:hidden': '']">
                {{ title }}
            </p>
        </div>
        <p class="title text-xs font-semibold text-gray-700 dark:text-gray-200 transition-colors" :class="[`group-hover:text-${color}-500 dark:group-hover:text-${color}-300`, onlyIconMobile ? 'max-md:hidden': '']">
            {{ title }}
        </p>

    </div>
</template>

<style scoped lang="scss">

</style>
